<template>
	<div
		class="c-schedule-item"
		:class="{
			'c-schedule-item--inline': inline
		}"
		:style="insetCalendarColorVar(item.calendarThemeColor)"
		@click="handleClickSchedule"
	>
		<div class="c-schedule-item-title text-overflow">
			{{ getScheduleTheme }}
		</div>
		<div class="c-schedule-item-content">
			<div class="c-schedule-calendar">{{ getCalendarName }}</div>
			<div v-if="getScheduleValues.length" class="c-schedule-item-info">
				<div v-for="(value, index) in getScheduleValues" :key="index" class="c-schedule-item-value">
					<span>{{ value }}</span>
				</div>
			</div>
		</div>
		<div v-if="inline" class="c-schedule-item-hr"></div>
	</div>
</template>

<script>
import {
	insetCalendarColorVar,
	checkScheduleHourHide,
	SCHEDULE_CUSTOMS_TYPE,
	nonCalendarPermission
} from '@/store/modules/calendar';
import $i18n, { EN } from '@/assets/js/i18n';
import { useCurrentContext } from '@rebuild/materials/shared/customs_calendar/context';
import { computed } from 'vue';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

export default {
	props: {
		item: {
			type: Object,
			default: () => {
				return {};
			}
		},
		inline: {
			type: Boolean,
			default: false
		},
		formatDate: {
			type: Function,
			default: null
		}
	},
	data() {
		return {
			insetCalendarColorVar
		};
	},
	computed: {
		getScheduleDate() {
			const { scheduleStartTime, scheduleEndTime } = this.item;
			if (this.formatDate) {
				return this.formatDate(this.item);
			}
			const disVisibleHour = checkScheduleHourHide(this.item);
			if (disVisibleHour) {
				return this.$moment(scheduleStartTime).format('YYYY-MM-DD');
			}
			return `${this.$moment(scheduleStartTime).format('HH:mm')} - ${this.$moment(scheduleEndTime).format(
				'HH:mm'
			)}`;
		},
		getScheduleTheme() {
			if (!this.item) return '-';
			const { calendarVO = {}, scheduleTheme } = this.item;
			return nonCalendarPermission(calendarVO) ? this.$t('enterprise.Busy') : scheduleTheme || '-';
		},
		getScheduleValues() {
			const { customsType, announcementVO } = this.item;
			let renderValues = [];
			const date = this.getScheduleDate;
			if (date) renderValues.push(date);
			if (customsType === SCHEDULE_CUSTOMS_TYPE.ANNOUNCEMENT && announcementVO && $i18n.locale !== EN) {
				renderValues.push(announcementVO.annoClassif);
			}
			return renderValues;
		},
		getCalendarName() {
			const { calendarName, calendarVO } = this.item;
			const defaultName = calendarName;
			const calendarTabs = this.calendarConfig?.tab || [];
			const findCalendar = calendarTabs.find(c => c.id == calendarVO.id);
			return (findCalendar && findCalendar.name) || defaultName || '-';
		}
	},
	methods: {
		handleClickSchedule() {
			const { customsType, announcementVO, newsVO } = this.item;
			if (customsType === SCHEDULE_CUSTOMS_TYPE.IRSTORE) {
				this.goInvestmentActivity();
			}
			if (customsType === SCHEDULE_CUSTOMS_TYPE.ANNOUNCEMENT) {
				this.viewModule('announcement', announcementVO);
			}
			if (customsType === SCHEDULE_CUSTOMS_TYPE.NEWS) {
				this.viewModule('news', newsVO);
			}
		},
		goInvestmentActivity() {
			const { investmentActivityVO, investmentActivityType } = this.item;
			if (investmentActivityType === 1) {
				this.viewModule('roadshow', investmentActivityVO);
			}
			if (investmentActivityType === 2) {
				this.viewModule('offline', investmentActivityVO);
			}
			if (investmentActivityType === 3) {
				this.viewModule('research', investmentActivityVO);
			}
		}
	},
	setup() {
		const ctx = useCurrentContext();
		const calendarConfig = computed(() => ctx.calendarConfig);
		const { viewModule } = useModuleNavigation();

		return {
			calendarConfig,
			viewModule
		};
	}
};
</script>

<style lang="less" scoped>
@import '../../../../style/mixin/mixins.less';
@import '../../../../style/mixin/border-radius.less';

.c-schedule-item {
	padding: 0.14rem 0.12rem;
	background: #fff;
	position: relative;

	&--inline {
		margin-top: 0 !important;
	}

	.c-schedule-item-hr {
		position: absolute !important;
		left: 0.12rem;
		right: 0.12rem;
		bottom: 0;
		height: 1px;
		.thinner-border-bottom(#e5e6eb);
	}
	&:last-child {
		.c-schedule-item-hr {
			display: none;
		}
	}

	& + .c-schedule-item {
		margin-top: 0.14rem;
	}
	.c-schedule-item-margin {
		margin-left: 0.2rem;
	}
	.c-schedule-item-title {
		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.14rem;
		font-style: normal;
		font-weight: 500;
		line-height: 0.2rem;
	}
	.c-schedule-item-content {
		margin-top: 0.04rem;
		display: flex;
		align-items: center;
	}
	.c-schedule-calendar {
		margin-right: 0.08rem;
		padding: 0 0.04rem;
		font-size: 0.1rem;
		line-height: 0.18rem;
		background: var(--calendar-color);
		color: #fff;
	}
	.c-schedule-item-info {
		flex: none;
		display: flex;
		align-items: center;
	}
	.c-schedule-item-value {
		color: #666;

		& + .c-schedule-item-value {
			margin-left: 0.16rem;
			position: relative;

			&::before {
				content: '';
				position: absolute;
				top: 0.02rem;
				left: -0.08rem;
				bottom: 0.02rem;
				width: 1px;
				background: #666;
			}
		}
		span {
			font-family: 'PingFang SC';
			font-size: 0.12rem;
			font-style: normal;
			font-weight: 400;
			line-height: 0.17rem;
		}
	}
}
</style>
